import React, { Component } from "react";
import { Button, Card, Form } from "semantic-ui-react";

class TagForm extends Component {
  state = {
    input: {
      name: "",
      visible: false
    }
  };
  handleChange = (event, { name, value }) => {
    this.setState(state => {
      return { input: { ...state.input, [name]: value } };
    });
  };
  handleToggleVisible = () => {
    this.setState(state => {
      return { input: { ...state.input, visible: !state.input.visible } };
    });
  };
  handleSubmit = () => {
    this.props.submit(this.state.input).then(this.props.hide);
  };
  handleCancel = event => {
    event.preventDefault();
    this.props.hide();
  };

  render() {
    return (
      <Card>
        <div style={{ padding: "1rem 2rem" }}>
          <Form onSubmit={this.handleSubmit}>
            <Form.Input
              label="Tag Name"
              name="name"
              id="name-input"
              value={this.state.input.name}
              onChange={this.handleChange}
            />
            <Form.Checkbox
              label="Visibility"
              name="visible"
              id="visible-input"
              checked={this.state.input.visible}
              onChange={this.handleToggleVisible}
            />
            <Button primary type="submit" loading={this.props.loading}>
              Create tag
            </Button>
            <Button onClick={this.handleCancel}>Cancel</Button>
          </Form>
        </div>
      </Card>
    );
  }
}

export default TagForm;



// WEBPACK FOOTER //
// ./src/pages/Tags/TagForm.js